import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

export const columnStyles = css`
  .columns {
    display: flex;
    justify-content: space-between;
  }

  .column {
    width: 45%;
  }
`;

export const sectionCSS = css`
  h3 {
    margin-bottom: 0;
    color: ${colors.G2};
    font-size: 0.75em;
    font-weight: 600;
    text-transform: uppercase;
  }
`;
